export default {
  // From ASTM E308-01
  A: { X: 1.09850 * 100, Y: 1.00000 * 100, Z: 0.35585 * 100 },

  // From Wyszecki & Stiles, p. 769
  B: { X: 0.99072 * 100, Y: 1.00000 * 100, Z: 0.85223 * 100 },

  // From ASTM E308-01
  C: { X: 0.98074 * 100, Y: 1.00000 * 100, Z: 1.18232 * 100 },

  // From ASTM E308-01
  D50: { X: 0.96422 * 100, Y: 1.00000 * 100, Z: 0.82521 * 100 },

  // From ASTM E308-01
  D55: { X: 0.95682 * 100, Y: 1.00000 * 100, Z: 0.92149 * 100 },

  // From ASTM E308-01
  D65: { X: 0.95047 * 100, Y: 1.00000 * 100, Z: 1.08883 * 100 },

  // From ASTM E308-01
  D75: { X: 0.94972 * 100, Y: 1.00000 * 100, Z: 1.22638 * 100 },

  // From ASTM E308-01
  E: { X: 1.00000 * 100, Y: 1.00000 * 100, Z: 1.00000 * 100 },

  // From ASTM E308-01
  F2: { X: 0.99186 * 100, Y: 1.00000 * 100, Z: 0.67393 * 100 },

  // From ASTM E308-01
  F7: { X: 0.95041 * 100, Y: 1.00000 * 100, Z: 1.08747 * 100 },

  // From ASTM E308-01
  F11: { X: 1.00962 * 100, Y: 1.00000 * 100, Z: 0.64350 * 100 }
}
